import { useLocation } from "react-router-dom"

export function useRevenueParams() {
  const { pathname, search } = useLocation()
  const params = new URLSearchParams(search)

  const hasParam = (k: string) => {
    return !!params.has(k) && params.get(k) !== "All"
  }

  const getParam = (k: string) => {
    return params.get(k) || ""
  }

  const clientParam = getParam("client")
  const brandParam = getParam("brand")
  const regionParam = getParam("region")
  const marketParam = getParam("market")
  const yearParam = getParam("year")
  const scenarioParam = getParam("scenario")
  const isGCFParam = getParam("isGCF")

  const isStream =
    brandParam === "Blue Stream" ||
    brandParam === "Red Stream" ||
    brandParam === "Magenta Stream" ||
    brandParam === "Silver Stream"

  const hasClientViewParamSelected =
    hasParam("client") || brandParam === "GCF" || isStream

  const globalEnabled =
    !hasParam("region") &&
    !hasParam("market") &&
    !hasParam("client") &&
    !hasParam("brand")
  const marketEnabled = hasParam("market") && hasParam("region")
  const clientEnabled = hasParam("client")
  const regionEnabled =
    hasParam("region") &&
    !hasParam("market") &&
    !hasParam("client") &&
    !hasParam("brand")
  const brandEnabled =
    hasParam("brand") &&
    brandParam !== "GCF" &&
    brandParam !== "Blue Stream" &&
    brandParam !== "Red Stream" &&
    !hasParam("client")

  const hasParamsLoaded =
    !!regionParam &&
    !!marketParam &&
    !!brandParam &&
    !!yearParam &&
    !!scenarioParam

  return {
    pathname,
    search,
    params,
    hasParam,
    getParam,
    clientParam,
    brandParam,
    regionParam,
    marketParam,
    yearParam,
    scenarioParam,
    globalEnabled,
    regionEnabled,
    marketEnabled,
    clientEnabled,
    brandEnabled,
    hasClientViewParamSelected,
    isStream,
    isGCFParam,
    hasParamsLoaded,
  }
}
